import React from "react";

export const Logo = (props: any) => (
  <svg
    {...props}
    viewBox="0 0 600 180"
    fill="none"
    role="img"
    aria-label="Logo"
  >
    <g clipPath="url(#clip0_5150_33)">
      <path d="M422.716 3.40002H3.3999V176.6H422.716V3.40002Z" fill="white" />
      <path
        d="M419.316 6.8V173.2H6.8V6.8H419.316ZM426.116 0H0V180H426.116V0Z"
        fill="black"
      />
      <path
        d="M41 121.724V72.8601H64.748C78.436 72.8601 85.28 78.2201 85.28 88.9441C85.28 94.4201 83.524 98.4881 80.008 101.16C76.496 103.828 71.136 105.164 63.924 105.164H51.812V121.724H41ZM63.856 96.6081C67.508 96.6081 70.176 95.9841 71.864 94.7281C73.552 93.4721 74.396 91.5241 74.396 88.8761C74.396 86.2761 73.572 84.3801 71.932 83.1961C70.288 82.0081 67.644 81.4161 63.992 81.4161H51.812V96.6081H63.856Z"
        fill="black"
      />
      <path
        d="M107.452 121.724V102.22L86.7842 72.8601H99.0362L113.064 93.3921L127.228 72.8601H139.068L118.4 102.22V121.724H107.452Z"
        fill="black"
      />
      <path
        d="M190.192 104.82C189.416 110.616 186.804 115.088 182.356 118.232C177.908 121.38 172.032 122.952 164.732 122.952C159.256 122.952 154.464 121.948 150.36 119.94C146.256 117.932 143.084 114.992 140.848 111.112C138.612 107.236 137.492 102.624 137.492 97.288C137.492 92.224 138.576 87.764 140.744 83.908C142.912 80.052 146.048 77.04 150.152 74.876C154.26 72.708 159.092 71.624 164.66 71.624C178.208 71.624 186.444 77.212 189.364 88.388L178.48 89.688C177.34 86.448 175.684 84.124 173.52 82.708C171.356 81.292 168.4 80.588 164.66 80.588C159.776 80.588 155.924 82.072 153.096 85.036C150.268 88 148.852 92.084 148.852 97.284C148.852 102.532 150.264 106.624 153.096 109.568C155.924 112.512 159.848 113.98 164.864 113.98C168.924 113.98 172.12 113.228 174.444 111.724C176.772 110.22 178.32 107.916 179.096 104.812H190.192V104.82Z"
        fill="black"
      />
      <path
        d="M253.356 97.2919C253.356 102.448 252.224 106.952 249.964 110.808C247.708 114.664 244.444 117.652 240.176 119.772C235.908 121.892 230.836 122.952 224.948 122.952C219.288 122.952 214.352 121.936 210.132 119.908C205.912 117.876 202.628 114.936 200.276 111.08C197.924 107.224 196.752 102.628 196.752 97.2919C196.752 92.1359 197.88 87.6319 200.14 83.7759C202.396 79.9199 205.66 76.9319 209.928 74.8119C214.192 72.6919 219.268 71.6279 225.156 71.6279C230.812 71.6279 235.752 72.6439 239.972 74.6719C244.192 76.7039 247.476 79.6479 249.828 83.4999C252.18 87.3599 253.356 91.9559 253.356 97.2919ZM241.996 97.2919C241.996 91.9999 240.512 87.8919 237.548 84.9719C234.58 82.0519 230.408 80.5919 225.024 80.5919C219.684 80.5919 215.532 82.0639 212.568 85.0039C209.604 87.9479 208.12 92.0439 208.12 97.2879C208.12 102.58 209.604 106.688 212.568 109.608C215.532 112.528 219.708 113.988 225.092 113.988C230.432 113.988 234.58 112.516 237.548 109.576C240.512 106.636 241.996 102.54 241.996 97.2919Z"
        fill="black"
      />
      <path
        d="M301.124 121.724L272.86 87.5761V121.724H262.388V72.8601H272.38L300.648 107.008V72.8601H311.116V121.724H301.124Z"
        fill="black"
      />
      <path
        d="M325.768 87.7163C322.188 83.4443 320.4 78.4923 320.4 72.8603C320.4 67.2283 322.188 62.2763 325.768 58.0083H332.38C330.74 60.4083 329.54 62.8003 328.78 65.1923C328.02 67.5803 327.636 70.1403 327.636 72.8643C327.636 75.5883 328.016 78.1443 328.78 80.5363C329.544 82.9243 330.744 85.3203 332.38 87.7243H325.768V87.7163Z"
        fill="black"
      />
      <path d="M335.776 83.424V58.7H343.048V83.424H335.776Z" fill="black" />
      <path
        d="M355.516 83.424V64.656H346.304V58.7H371.996V64.656H362.784V83.424H355.516Z"
        fill="black"
      />
      <path
        d="M372.968 87.716C374.608 85.316 375.808 82.92 376.568 80.528C377.332 78.14 377.712 75.584 377.712 72.856C377.712 70.132 377.332 67.576 376.568 65.184C375.804 62.796 374.604 60.4 372.968 58H379.58C383.16 62.268 384.948 67.22 384.948 72.852C384.948 78.484 383.16 83.436 379.58 87.708H372.968V87.716Z"
        fill="black"
      />
      <path d="M596.6 3.40002H423.4V176.6H596.6V3.40002Z" fill="#F17A5D" />
      <path
        d="M593.2 6.8V173.2H426.8V6.8H593.2ZM600 0H420V180H600V0Z"
        fill="black"
      />
      <path
        d="M467.088 115.8V108.229C469.5 106.532 471.621 105.035 473.453 103.74C475.329 102.445 477.004 101.261 478.478 100.189C479.996 99.117 481.426 98.0897 482.766 97.107C486.071 94.695 488.55 92.7297 490.203 91.211C491.855 89.6477 492.994 88.2854 493.62 87.124C494.29 85.918 494.625 84.6227 494.625 83.238C494.625 81.0047 493.888 79.3074 492.414 78.146C490.984 76.9847 488.863 76.404 486.049 76.404C483.324 76.404 481.202 76.9624 479.684 78.079C478.165 79.1957 477.048 81.027 476.334 83.573L466.619 82.501C467.512 77.811 469.634 74.26 472.984 71.848C476.378 69.436 480.89 68.23 486.518 68.23C492.369 68.23 496.925 69.4807 500.186 71.982C503.446 74.4834 505.077 77.945 505.077 82.367C505.077 84.645 504.652 86.6997 503.804 88.531C503 90.3177 501.682 92.1267 499.851 93.958C498.019 95.7447 495.518 97.7547 492.347 99.988C489.086 102.311 485.423 104.812 481.359 107.492H506.015L504.742 115.8H467.088ZM538.255 115.8V105.951H511.455V98.313L537.719 69.503H547.635V98.313H555.005L553.933 105.951H547.635V115.8H538.255ZM538.255 79.888L521.371 98.313H538.255V79.888Z"
        fill="#1D1D1B"
      />
    </g>
    <defs>
      <clipPath id="clip0_5150_33">
        <rect width="600" height="180" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MobileLogo = (props: any) => (
  <svg {...props} viewBox="0 0 120 60" fill="none" role="img" aria-label="Logo">
    <g clipPath="url(#clip0_5311_2)">
      <mask
        id="mask0_5311_2"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="120"
        height="60"
      >
        <path d="M120 0H0V60H120V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_5311_2)">
        <path d="M120 0H0V60H120V0Z" fill="#FCE8DE" />
        <path d="M120 60V0H60V60H120Z" fill="#F17A5D" />
        <path
          d="M76.408 38V35.514C77.2 34.9567 77.8967 34.4653 78.498 34.04C79.114 33.6147 79.664 33.226 80.148 32.874C80.6467 32.522 81.116 32.1847 81.556 31.862C82.6413 31.07 83.4553 30.4247 83.998 29.926C84.5407 29.4127 84.9147 28.9653 85.12 28.584C85.34 28.188 85.45 27.7627 85.45 27.308C85.45 26.5747 85.208 26.0173 84.724 25.636C84.2547 25.2547 83.558 25.064 82.634 25.064C81.7393 25.064 81.0427 25.2473 80.544 25.614C80.0453 25.9807 79.6787 26.582 79.444 27.418L76.254 27.066C76.5473 25.526 77.244 24.36 78.344 23.568C79.4587 22.776 80.94 22.38 82.788 22.38C84.7093 22.38 86.2053 22.7907 87.276 23.612C88.3467 24.4333 88.882 25.57 88.882 27.022C88.882 27.77 88.7427 28.4447 88.464 29.046C88.2 29.6327 87.7673 30.2267 87.166 30.828C86.5647 31.4147 85.7433 32.0747 84.702 32.808C83.6313 33.5707 82.4287 34.392 81.094 35.272H89.19L88.772 38H76.408ZM100.436 38V34.766H91.6363V32.258L100.26 22.798H103.516V32.258H105.936L105.584 34.766H103.516V38H100.436ZM100.436 26.208L94.8923 32.258H100.436V26.208Z"
          fill="#0E1116"
        />
        <path
          d="M38.8369 20.7725C39.6581 23.8 39.0914 27.2611 37.1011 29.3283C34.741 31.7802 34.741 36.7728 37.1011 39.2218C40.105 42.3426 40.105 48.4642 37.1011 51.582C34.741 54.031 34.7425 59.0236 37.1011 61.477C38.2198 62.6371 38.9197 64.2219 39.2024 65.9133H42.7212V30.188C42.7212 26.6041 41.2873 23.2377 38.8369 20.7725Z"
          fill="#F17A5D"
        />
        <path
          d="M35.8213 50.3496C38.1815 47.9006 38.18 42.908 35.8213 40.4546C32.8189 37.3382 32.8174 31.2151 35.8213 28.0943C38.0054 25.8259 37.9018 20.9872 35.6511 18.405C33.7511 17.4003 31.6233 16.8853 29.4836 16.9283C22.7774 17.0629 17.2624 22.4048 16.8052 29.0147H29.2971L30.1998 29.9144V65.9134H37.4031C37.1486 64.6823 36.6263 63.5444 35.8213 62.7098C32.8174 59.589 32.8174 53.4674 35.8213 50.3496ZM26.0595 23.8223C25.2101 23.8223 24.522 23.1313 24.522 22.2805C24.522 21.4311 25.2101 20.743 26.0595 20.743C26.9088 20.743 27.5999 21.4311 27.5999 22.2805C27.5999 23.1298 26.9088 23.8223 26.0595 23.8223Z"
          fill="#FCE8DE"
        />
        <path
          d="M26.0594 20.7432C25.21 20.7432 24.522 21.4312 24.522 22.2806C24.522 23.13 25.21 23.8225 26.0594 23.8225C26.9088 23.8225 27.5998 23.1315 27.5998 22.2806C27.5998 21.4312 26.9088 20.7432 26.0594 20.7432Z"
          fill="#0E1116"
        />
        <path
          d="M38.8371 20.7728C41.2876 23.2381 42.7229 26.6045 42.7229 30.1884V65.9136H44.5001V30.1884C44.5001 24.7104 41.5465 19.6749 36.7847 17.001C36.8217 17.0394 36.8587 17.0779 36.8898 17.1164C37.8176 18.1359 38.4672 19.4115 38.8371 20.7728Z"
          fill="#0E1116"
        />
        <path
          d="M30.1998 65.9135V29.9145L29.2972 29.0148H16.8053C17.2625 22.4048 22.776 17.063 29.4836 16.9283C31.6219 16.8854 33.7512 17.4003 35.6512 18.4051C35.6201 18.3696 35.5935 18.3311 35.5624 18.2956L35.521 18.2468C35.5121 18.2349 35.5002 18.2246 35.4899 18.2127L36.7314 16.9653C36.7018 16.949 36.6737 16.9298 36.6441 16.9135C34.4378 15.712 31.9548 15.0964 29.4511 15.1497C21.4901 15.3095 15.0074 21.9209 15 29.8878L15.8997 30.7905H28.4256V65.912H30.1998V65.9135Z"
          fill="#0E1116"
        />
        <path
          d="M35.4883 18.2153C35.5001 18.2257 35.5105 18.2375 35.5194 18.2493L35.5608 18.2982C35.5919 18.3322 35.6185 18.3722 35.6496 18.4077C37.9017 20.9913 38.0038 25.83 35.8198 28.097C32.8159 31.2177 32.8174 37.3394 35.8198 40.4572C38.1799 42.9091 38.1799 47.9032 35.8198 50.3522C32.8159 53.4685 32.8159 59.5917 35.8198 62.7124C36.6247 63.547 37.1471 64.6849 37.4016 65.9161H39.2024C38.9198 64.2232 38.2199 62.6384 37.1012 61.4798C34.741 59.0279 34.741 54.0338 37.1012 51.5848C40.1051 48.467 40.1051 42.3454 37.1012 39.2246C34.741 36.7756 34.7425 31.783 37.1012 29.3311C39.0914 27.2639 39.6582 23.8028 38.8369 20.7753C38.467 19.4124 37.8174 18.1384 36.8896 17.1173C36.8585 17.0789 36.8201 17.0404 36.7845 17.0019C36.7697 16.9871 36.7579 16.9709 36.7431 16.9561L36.7298 16.9694L35.4883 18.2153Z"
          fill="#0E1116"
        />
        <path
          d="M42.9565 15.6825C42.9565 15.6544 42.9579 15.6263 42.9609 15.5967C42.9594 15.6263 42.9565 15.6544 42.9565 15.6825Z"
          fill="#0E1116"
        />
        <path
          d="M43.2165 16.3104C43.1956 16.2895 43.1791 16.2685 43.1611 16.2461C43.1791 16.2685 43.1956 16.291 43.2165 16.3104Z"
          fill="#0E1116"
        />
        <path
          d="M42.9727 15.8539C42.9668 15.8258 42.9639 15.7962 42.9609 15.7666C42.9639 15.7962 42.9683 15.8243 42.9727 15.8539Z"
          fill="#0E1116"
        />
        <path
          d="M43.0854 16.1485C43.0914 16.1574 43.0974 16.1634 43.1034 16.1724C43.0884 16.1499 43.075 16.126 43.063 16.1006C43.0705 16.1155 43.075 16.132 43.0854 16.1485Z"
          fill="#0E1116"
        />
        <path
          d="M43.2168 15.0568C43.2378 15.0359 43.2602 15.018 43.2827 15C43.2587 15.018 43.2363 15.0374 43.2168 15.0568Z"
          fill="#0E1116"
        />
        <path
          d="M43.3533 16.422C43.3266 16.4042 43.3015 16.3835 43.2778 16.3643C43.303 16.385 43.3281 16.4057 43.3533 16.422Z"
          fill="#0E1116"
        />
        <path
          d="M42.9746 15.5121C42.9806 15.484 42.988 15.4558 42.9968 15.4277C42.988 15.4558 42.9791 15.484 42.9746 15.5121Z"
          fill="#0E1116"
        />
        <path
          d="M43.0218 16.0169C43.0114 15.9903 43.0026 15.9622 42.9937 15.9355C43.0026 15.9637 43.0114 15.9903 43.0218 16.0169Z"
          fill="#0E1116"
        />
        <path
          d="M43.0234 15.349C43.0353 15.3194 43.05 15.2913 43.0663 15.2617C43.05 15.2898 43.0353 15.3194 43.0234 15.349Z"
          fill="#0E1116"
        />
        <path
          d="M23.4836 30.0039V34.6103L21.3706 36.7249V30.0039H25.5982V34.6103L23.4836 36.7249V34.6192"
          fill="#E94135"
        />
        <path
          d="M20.8364 38.0142V29.4717H26.1309V34.8328L22.9494 38.0142V35.8996L20.8364 38.0142ZM24.0178 34.8328V35.438L25.0655 34.3903V30.5371H24.0178V34.8328ZM21.9033 30.5371V35.438L22.9509 34.3903V30.5371H21.9033Z"
          fill="#0E1116"
        />
        <path d="M60.5 -1V60" stroke="#0E1116" strokeWidth="3" />
      </g>
      <path
        d="M118.5 1.5H1.5V58.5H118.5V1.5Z"
        stroke="#0E1116"
        strokeWidth="3"
      />
    </g>
    <defs>
      <clipPath id="clip0_5311_2">
        <rect width="120" height="60" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
